import type { ActionReducer } from '@ngrx/store';
import { createReducer, on } from '@ngrx/store';
import { getFieldValue } from '@core/jss-utils';

import { setEcmpAffiliateLogo } from './ecmp-logos.actions';
import type {
  EcmpAffiliateLogo,
  EcmpAffiliateLogosState,
  SCEcmpAffiliateLogo,
} from './ecmp-logos.interface';

export const ecmpLogosSelectorKey = 'ecmp-logos';

const initialState: EcmpAffiliateLogosState = {};

const mapScAffiliateLogo = (logo: SCEcmpAffiliateLogo): EcmpAffiliateLogo => ({
  ecmp: getFieldValue(logo.fields, 'ecmp', ''),
  logo: getFieldValue<{ src: string }>(logo.fields, 'image', { src: '' }).src,
  description: getFieldValue<{ alt: string }>(logo.fields, 'image', { alt: '' })
    .alt,
  url: getFieldValue<{ href: string }>(logo.fields, 'url', { href: '' }).href,
  target:
    getFieldValue<{ target: string }>(logo.fields, 'url', {
      target: '',
    }).target || '_self',
  showOnDesktop: getFieldValue(logo.fields, 'showOnDesktop', true),
  showOnMobile: getFieldValue(logo.fields, 'showOnMobile', true),
  showOnTablet: getFieldValue(logo.fields, 'showOnTablet', true),
});

export const ecmpLogosReducer: ActionReducer<EcmpAffiliateLogosState> =
  createReducer(
    initialState,
    on(setEcmpAffiliateLogo, (_, action) => mapScAffiliateLogo(action.ecmpLogo))
  );
